import { actionTypes } from "../../reducers/billingActionTypes";
import { Plan, Subscription, Invoice, Donation, AccountFields, CancelSubscriptionPayload } from "../../../../types/billing";
import { PaymentMethod, PaymentHistory } from "../../../../interfaces/billing";

export const billingActions = {
  setPlans: (plans: Plan[]) => ({ type: actionTypes.GET_PLANS_SUCCESS, payload: plans }),
  setSubscription: (data: { subscription: Subscription | null; has_active_subscription: boolean; donation?: Donation | null } & AccountFields) =>
    ({ type: actionTypes.GET_SUBSCRIPTION_SUCCESS, payload: data }),
  cancelDonationSuccess: (data: { donation: Donation | null }) =>
    ({ type: actionTypes.CANCEL_DONATION_SUCCESS, payload: data }),
  accountActionSuccess: () => ({ type: actionTypes.ACCOUNT_ACTION_SUCCESS }),
  accountActionError: (error: { message: string | null; fieldErrors?: Record<string, string>; code?: string | null }) =>
    ({ type: actionTypes.ACCOUNT_ACTION_ERROR, payload: error }),
  accountActionReset: () => ({ type: actionTypes.ACCOUNT_ACTION_RESET }),
  setInvoices: (invoices: Invoice[]) => ({ type: actionTypes.GET_INVOICES_SUCCESS, payload: invoices }),
  setError: (error: string) => ({ type: actionTypes.GET_SUBSCRIPTION_ERROR, payload: error }),
  setPaymentMethods: (paymentMethods: PaymentMethod[]) =>
    ({ type: actionTypes.GET_PAYMENT_METHODS_SUCCESS, payload: paymentMethods }),
  addPaymentMethodSuccess: (paymentMethod: PaymentMethod) =>
    ({ type: actionTypes.ADD_PAYMENT_METHOD_SUCCESS, payload: paymentMethod }),
  deletePaymentMethodSuccess: (id: string) =>
    ({ type: actionTypes.DELETE_PAYMENT_METHOD_SUCCESS, payload: id }),
  setDefaultPaymentMethodSuccess: (id: string) =>
    ({ type: actionTypes.SET_DEFAULT_PAYMENT_METHOD_SUCCESS, payload: id }),
  setSetupIntentSecret: (secret: string) =>
    ({ type: actionTypes.GET_SETUP_INTENT_SUCCESS, payload: secret }),
  setPaymentHistory: (history: PaymentHistory[]) =>
    ({ type: actionTypes.GET_PAYMENT_HISTORY_SUCCESS, payload: history }),
  // NEW: Billing from auth
  setBillingFromAuth: (payload: any) => ({ type: actionTypes.SET_BILLING_FROM_AUTH, payload }),
  dismissWelcomeSuccess: () => ({ type: actionTypes.DISMISS_WELCOME_SUCCESS }),
  purchaseSetupFeeSuccess: (data: any) => ({ type: actionTypes.PURCHASE_SETUP_FEE_SUCCESS, payload: data }),
  uploadManagedFileSuccess: () => ({ type: actionTypes.UPLOAD_MANAGED_FILE_SUCCESS }),
  getUsageSuccess: (data: any) => ({ type: actionTypes.GET_USAGE_SUCCESS, payload: data }),
  setManagedUploadAdminMessage: (message: string | null) => ({
    type: actionTypes.SET_MANAGED_UPLOAD_ADMIN_MESSAGE,
    payload: message,
  }),
};

export const billingTriggerActions = {
  getPlans: () => ({ type: actionTypes.GET_PLANS }),
  getSubscription: () => ({ type: actionTypes.GET_SUBSCRIPTION }),
  getInvoices: (params?: { perPage?: number; page?: number }) => ({ type: actionTypes.GET_INVOICES, params }),
  createCheckoutSession: (data: { plan_id: number; billing_cycle: "monthly" | "yearly" | "onetime"; success_url?: string; cancel_url?: string }) =>
    ({ type: actionTypes.CREATE_CHECKOUT_SESSION, data }),
  createPortalSession: () => ({ type: actionTypes.CREATE_PORTAL_SESSION }),
  // No payload = plain pause-at-period-end (the long-standing behaviour).
  cancelSubscription: (payload: CancelSubscriptionPayload = {}) => ({ type: actionTypes.CANCEL_SUBSCRIPTION, payload }),
  closeAccount: (confirmName: string) => ({ type: actionTypes.CLOSE_ACCOUNT, payload: { confirmName } }),
  keepAccount: () => ({ type: actionTypes.KEEP_ACCOUNT }),
  resumeSubscription: () => ({ type: actionTypes.RESUME_SUBSCRIPTION }),
  cancelDonation: () => ({ type: actionTypes.CANCEL_DONATION }),
  getPaymentMethods: () => ({ type: actionTypes.GET_PAYMENT_METHODS }),
  addPaymentMethod: (paymentMethodId: string) =>
    ({ type: actionTypes.ADD_PAYMENT_METHOD, paymentMethodId }),
  deletePaymentMethod: (id: string) =>
    ({ type: actionTypes.DELETE_PAYMENT_METHOD, id }),
  setDefaultPaymentMethod: (id: string) =>
    ({ type: actionTypes.SET_DEFAULT_PAYMENT_METHOD, id }),
  getSetupIntent: () => ({ type: actionTypes.GET_SETUP_INTENT }),
  getPaymentHistory: (params?: { perPage?: number; page?: number }) =>
    ({ type: actionTypes.GET_PAYMENT_HISTORY, params }),
  getCustomer: () => ({ type: actionTypes.GET_CUSTOMER }),
  updateCustomer: (data: { name: string; email: string }) =>
    ({ type: actionTypes.UPDATE_CUSTOMER, data }),
  getInvoice: (invoiceId: string) => ({ type: actionTypes.GET_INVOICE, invoiceId }),
  // NEW triggers
  dismissWelcome: () => ({ type: actionTypes.DISMISS_WELCOME_TRIGGER }),
  purchaseSetupFee: (planId: number) => ({ type: actionTypes.PURCHASE_SETUP_FEE_TRIGGER, planId }),
  uploadManagedFile: (files: File[]) => ({ type: actionTypes.UPLOAD_MANAGED_FILE_TRIGGER, files }),
  getUsage: () => ({ type: actionTypes.GET_USAGE_TRIGGER }),
  confirmSetupPurchase: () => ({ type: actionTypes.CONFIRM_SETUP_PURCHASE }),
  setAwaitingPaymentConfirmation: (value: boolean) =>
    ({ type: actionTypes.SET_AWAITING_PAYMENT_CONFIRMATION, payload: value }),
};
